export const DEFAULT_USED_COLOR = [
    {
        bgColor: "bg-slate-50",
        textColor: "text-slate-500"
    }];

export const DEFAULT_COLOR = {
    colorKey: "slate",
    colorCodeKey: "500",
    hexCode: "#64748B"
}

export const DEFAULT_STROKE_COLOR = {
    colorKey: "yellow",
    colorCodeKey: "400",
    hexCode: "#FACC15"
}

export const DEFAULT_SHADOW_COLOR = {
    colorKey: "gray",
    colorCodeKey: "300",
    hexCode: "#D1D5DB"
}

export const COLOR_LIST = [
    {
        "colorName": "White",
        "colorKey": "white",
        "colorCodes": [{
            "colorCodeName": "50",
            "colorCodeKey": "50",
            "bgColor": "bg-white",
            "textColor": "text-white",
            "hexCode": "#FFFFFF"
        }]
    },
    {
        "colorName": "Black",
        "colorKey": "black",
        "colorCodes": [{
            "colorCodeName": "50",
            "colorCodeKey": "50",
            "bgColor": "bg-black",
            "textColor": "text-black",
            "hexCode": "#000000"
        }]
    },
    {
        "colorName": "Slate",
        "colorKey": "slate",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-slate-50",
                "textColor": "text-slate-50",
                "hexCode": "#F8FAFC"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-slate-100",
                "textColor": "text-slate-100",
                "hexCode": "#F1F5F9"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-slate-200",
                "textColor": "text-slate-200",
                "hexCode": "#E2E8F0"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-slate-300",
                "textColor": "text-slate-300",
                "hexCode": "#CBD5E1"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-slate-400",
                "textColor": "text-slate-400",
                "hexCode": "#94A3B8"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-slate-500",
                "textColor": "text-slate-500",
                "hexCode": "#64748B"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-slate-600",
                "textColor": "text-slate-600",
                "hexCode": "#475569"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-slate-700",
                "textColor": "text-slate-700",
                "hexCode": "#334155"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-slate-800",
                "textColor": "text-slate-800",
                "hexCode": "#1E293B"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-slate-900",
                "textColor": "text-slate-900",
                "hexCode": "#0F172A"
            }
        ]
    },
    {
        "colorName": "Gray",
        "colorKey": "gray",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-gray-50",
                "textColor": "text-gray-50",
                "hexCode": "#F9FAFB"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-gray-100",
                "textColor": "text-gray-100",
                "hexCode": "#F3F4F6"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-gray-200",
                "textColor": "text-gray-200",
                "hexCode": "#E5E7EB"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-gray-300",
                "textColor": "text-gray-300",
                "hexCode": "#D1D5DB"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-gray-400",
                "textColor": "text-gray-400",
                "hexCode": "#9CA3AF"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-gray-500",
                "textColor": "text-gray-500",
                "hexCode": "#6B7280"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-gray-600",
                "textColor": "text-gray-600",
                "hexCode": "#4B5563"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-gray-700",
                "textColor": "text-gray-700",
                "hexCode": "#374151"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-gray-800",
                "textColor": "text-gray-800",
                "hexCode": "#1F2937"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-gray-900",
                "textColor": "text-gray-900",
                "hexCode": "#111827"
            }
        ]
    },
    {
        "colorName": "Zinc",
        "colorKey": "zinc",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-zinc-50",
                "textColor": "text-zinc-50",
                "hexCode": "#FAFAFA"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-zinc-100",
                "textColor": "text-zinc-100",
                "hexCode": "#F4F4F5"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-zinc-200",
                "textColor": "text-zinc-200",
                "hexCode": "#E4E4E7"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-zinc-300",
                "textColor": "text-zinc-300",
                "hexCode": "#D4D4D8"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-zinc-400",
                "textColor": "text-zinc-400",
                "hexCode": "#A1A1AA"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-zinc-500",
                "textColor": "text-zinc-500",
                "hexCode": "#71717A"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-zinc-600",
                "textColor": "text-zinc-600",
                "hexCode": "#52525B"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-zinc-700",
                "textColor": "text-zinc-700",
                "hexCode": "#3F3F46"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-zinc-800",
                "textColor": "text-zinc-800",
                "hexCode": "#27272A"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-zinc-900",
                "textColor": "text-zinc-900",
                "hexCode": "#18181B"
            }
        ]
    },
    {
        "colorName": "Neutral",
        "colorKey": "neutral",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-neutral-50",
                "textColor": "text-neutral-50",
                "hexCode": "#FAFAFA"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-neutral-100",
                "textColor": "text-neutral-100",
                "hexCode": "#F5F5F5"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-neutral-200",
                "textColor": "text-neutral-200",
                "hexCode": "#E5E5E5"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-neutral-300",
                "textColor": "text-neutral-300",
                "hexCode": "#D4D4D4"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-neutral-400",
                "textColor": "text-neutral-400",
                "hexCode": "#A3A3A3"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-neutral-500",
                "textColor": "text-neutral-500",
                "hexCode": "#737373"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-neutral-600",
                "textColor": "text-neutral-600",
                "hexCode": "#525252"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-neutral-700",
                "textColor": "text-neutral-700",
                "hexCode": "#404040"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-neutral-800",
                "textColor": "text-neutral-800",
                "hexCode": "#262626"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-neutral-900",
                "textColor": "text-neutral-900",
                "hexCode": "#171717"
            }
        ]
    },
    {
        "colorName": "Stone",
        "colorKey": "stone",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-stone-50",
                "textColor": "text-stone-50",
                "hexCode": "#FAFAF9"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-stone-100",
                "textColor": "text-stone-100",
                "hexCode": "#F5F5F4"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-stone-200",
                "textColor": "text-stone-200",
                "hexCode": "#E7E5E4"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-stone-300",
                "textColor": "text-stone-300",
                "hexCode": "#D6D3D1"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-stone-400",
                "textColor": "text-stone-400",
                "hexCode": "#A8A29E"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-stone-500",
                "textColor": "text-stone-500",
                "hexCode": "#78716C"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-stone-600",
                "textColor": "text-stone-600",
                "hexCode": "#57534E"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-stone-700",
                "textColor": "text-stone-700",
                "hexCode": "#44403C"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-stone-800",
                "textColor": "text-stone-800",
                "hexCode": "#292524"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-stone-900",
                "textColor": "text-stone-900",
                "hexCode": "#1C1917"
            }
        ]
    },
    {
        "colorName": "Red",
        "colorKey": "red",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-red-50",
                "textColor": "text-red-50",
                "hexCode": "#FEF2F2"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-red-100",
                "textColor": "text-red-100",
                "hexCode": "#FEE2E2"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-red-200",
                "textColor": "text-red-200",
                "hexCode": "#FECACA"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-red-300",
                "textColor": "text-red-300",
                "hexCode": "#FCA5A5"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-red-400",
                "textColor": "text-red-400",
                "hexCode": "#F87171"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-red-500",
                "textColor": "text-red-500",
                "hexCode": "#EF4444"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-red-600",
                "textColor": "text-red-600",
                "hexCode": "#DC2626"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-red-700",
                "textColor": "text-red-700",
                "hexCode": "#B91C1C"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-red-800",
                "textColor": "text-red-800",
                "hexCode": "#991B1B"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-red-900",
                "textColor": "text-red-900",
                "hexCode": "#7F1D1D"
            }
        ]
    },
    {
        "colorName": "Orange",
        "colorKey": "orange",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-orange-50",
                "textColor": "text-orange-50",
                "hexCode": "#FFF7ED"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-orange-100",
                "textColor": "text-orange-100",
                "hexCode": "#FFEDD5"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-orange-200",
                "textColor": "text-orange-200",
                "hexCode": "#FED7AA"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-orange-300",
                "textColor": "text-orange-300",
                "hexCode": "#FDBA74"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-orange-400",
                "textColor": "text-orange-400",
                "hexCode": "#FB923C"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-orange-500",
                "textColor": "text-orange-500",
                "hexCode": "#F97316"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-orange-600",
                "textColor": "text-orange-600",
                "hexCode": "#EA580C"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-orange-700",
                "textColor": "text-orange-700",
                "hexCode": "#C2410C"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-orange-800",
                "textColor": "text-orange-800",
                "hexCode": "#9A3412"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-orange-900",
                "textColor": "text-orange-900",
                "hexCode": "#7C2D12"
            }
        ]
    },
    {
        "colorName": "Amber",
        "colorKey": "amber",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-amber-50",
                "textColor": "text-amber-50",
                "hexCode": "#FFFBEB"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-amber-100",
                "textColor": "text-amber-100",
                "hexCode": "#FEF3C7"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-amber-200",
                "textColor": "text-amber-200",
                "hexCode": "#FDE68A"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-amber-300",
                "textColor": "text-amber-300",
                "hexCode": "#FCD34D"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-amber-400",
                "textColor": "text-amber-400",
                "hexCode": "#FBBF24"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-amber-500",
                "textColor": "text-amber-500",
                "hexCode": "#F59E0B"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-amber-600",
                "textColor": "text-amber-600",
                "hexCode": "#D97706"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-amber-700",
                "textColor": "text-amber-700",
                "hexCode": "#B45309"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-amber-800",
                "textColor": "text-amber-800",
                "hexCode": "#92400E"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-amber-900",
                "textColor": "text-amber-900",
                "hexCode": "#78350F"
            }
        ]
    },
    {
        "colorName": "Yellow",
        "colorKey": "yellow",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-yellow-50",
                "textColor": "text-yellow-50",
                "hexCode": "#FEFCE8"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-yellow-100",
                "textColor": "text-yellow-100",
                "hexCode": "#FEF9C3"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-yellow-200",
                "textColor": "text-yellow-200",
                "hexCode": "#FEF08A"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-yellow-300",
                "textColor": "text-yellow-300",
                "hexCode": "#FDE047"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-yellow-400",
                "textColor": "text-yellow-400",
                "hexCode": "#FACC15"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-yellow-500",
                "textColor": "text-yellow-500",
                "hexCode": "#EAB308"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-yellow-600",
                "textColor": "text-yellow-600",
                "hexCode": "#CA8A04"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-yellow-700",
                "textColor": "text-yellow-700",
                "hexCode": "#A16207"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-yellow-800",
                "textColor": "text-yellow-800",
                "hexCode": "#854D0E"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-yellow-900",
                "textColor": "text-yellow-900",
                "hexCode": "#713F12"
            }
        ]
    },
    {
        "colorName": "Lime",
        "colorKey": "lime",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-lime-50",
                "textColor": "text-lime-50",
                "hexCode": "#F7FEE7"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-lime-100",
                "textColor": "text-lime-100",
                "hexCode": "#ECFCCB"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-lime-200",
                "textColor": "text-lime-200",
                "hexCode": "#D9F99D"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-lime-300",
                "textColor": "text-lime-300",
                "hexCode": "#BEF264"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-lime-400",
                "textColor": "text-lime-400",
                "hexCode": "#A3E635"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-lime-500",
                "textColor": "text-lime-500",
                "hexCode": "#84CC16"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-lime-600",
                "textColor": "text-lime-600",
                "hexCode": "#65A30D"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-lime-700",
                "textColor": "text-lime-700",
                "hexCode": "#4D7C0F"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-lime-800",
                "textColor": "text-lime-800",
                "hexCode": "#3F6212"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-lime-900",
                "textColor": "text-lime-900",
                "hexCode": "#365314"
            }
        ]
    },
    {
        "colorName": "Green",
        "colorKey": "green",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-green-50",
                "textColor": "text-green-50",
                "hexCode": "#F0FDF4"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-green-100",
                "textColor": "text-green-100",
                "hexCode": "#DCFCE7"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-green-200",
                "textColor": "text-green-200",
                "hexCode": "#BBF7D0"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-green-300",
                "textColor": "text-green-300",
                "hexCode": "#86EFAC"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-green-400",
                "textColor": "text-green-400",
                "hexCode": "#4ADE80"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-green-500",
                "textColor": "text-green-500",
                "hexCode": "#22C55E"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-green-600",
                "textColor": "text-green-600",
                "hexCode": "#16A34A"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-green-700",
                "textColor": "text-green-700",
                "hexCode": "#15803D"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-green-800",
                "textColor": "text-green-800",
                "hexCode": "#166534"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-green-900",
                "textColor": "text-green-900",
                "hexCode": "#14532D"
            }
        ]
    },
    {
        "colorName": "Emerald",
        "colorKey": "emerald",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-emerald-50",
                "textColor": "text-emerald-50",
                "hexCode": "#ECFDF5"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-emerald-100",
                "textColor": "text-emerald-100",
                "hexCode": "#D1FAE5"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-emerald-200",
                "textColor": "text-emerald-200",
                "hexCode": "#A7F3D0"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-emerald-300",
                "textColor": "text-emerald-300",
                "hexCode": "#6EE7B7"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-emerald-400",
                "textColor": "text-emerald-400",
                "hexCode": "#34D399"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-emerald-500",
                "textColor": "text-emerald-500",
                "hexCode": "#10B981"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-emerald-600",
                "textColor": "text-emerald-600",
                "hexCode": "#059669"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-emerald-700",
                "textColor": "text-emerald-700",
                "hexCode": "#047857"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-emerald-800",
                "textColor": "text-emerald-800",
                "hexCode": "#065F46"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-emerald-900",
                "textColor": "text-emerald-900",
                "hexCode": "#064E3B"
            }
        ]
    },
    {
        "colorName": "Teal",
        "colorKey": "teal",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-teal-50",
                "textColor": "text-teal-50",
                "hexCode": "#F0FDFA"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-teal-100",
                "textColor": "text-teal-100",
                "hexCode": "#CCFBF1"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-teal-200",
                "textColor": "text-teal-200",
                "hexCode": "#99F6E4"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-teal-300",
                "textColor": "text-teal-300",
                "hexCode": "#5EEAD4"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-teal-400",
                "textColor": "text-teal-400",
                "hexCode": "#2DD4BF"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-teal-500",
                "textColor": "text-teal-500",
                "hexCode": "#14B8A6"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-teal-600",
                "textColor": "text-teal-600",
                "hexCode": "#0D9488"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-teal-700",
                "textColor": "text-teal-700",
                "hexCode": "#0F766E"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-teal-800",
                "textColor": "text-teal-800",
                "hexCode": "#115E59"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-teal-900",
                "textColor": "text-teal-900",
                "hexCode": "#134E4A"
            }
        ]
    },
    {
        "colorName": "Cyan",
        "colorKey": "cyan",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-cyan-50",
                "textColor": "text-cyan-50",
                "hexCode": "#ECFEFF"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-cyan-100",
                "textColor": "text-cyan-100",
                "hexCode": "#CFFAFE"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-cyan-200",
                "textColor": "text-cyan-200",
                "hexCode": "#A5F3FC"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-cyan-300",
                "textColor": "text-cyan-300",
                "hexCode": "#67E8F9"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-cyan-400",
                "textColor": "text-cyan-400",
                "hexCode": "#22D3EE"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-cyan-500",
                "textColor": "text-cyan-500",
                "hexCode": "#06B6D4"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-cyan-600",
                "textColor": "text-cyan-600",
                "hexCode": "#0891B2"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-cyan-700",
                "textColor": "text-cyan-700",
                "hexCode": "#0E7490"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-cyan-800",
                "textColor": "text-cyan-800",
                "hexCode": "#155E75"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-cyan-900",
                "textColor": "text-cyan-900",
                "hexCode": "#164E63"
            }
        ]
    },
    {
        "colorName": "Sky",
        "colorKey": "sky",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-sky-50",
                "textColor": "text-sky-50",
                "hexCode": "#F0F9FF"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-sky-100",
                "textColor": "text-sky-100",
                "hexCode": "#E0F2FE"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-sky-200",
                "textColor": "text-sky-200",
                "hexCode": "#BAE6FD"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-sky-300",
                "textColor": "text-sky-300",
                "hexCode": "#7DD3FC"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-sky-400",
                "textColor": "text-sky-400",
                "hexCode": "#38BDF8"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-sky-500",
                "textColor": "text-sky-500",
                "hexCode": "#0EA5E9"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-sky-600",
                "textColor": "text-sky-600",
                "hexCode": "#0284C7"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-sky-700",
                "textColor": "text-sky-700",
                "hexCode": "#0369A1"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-sky-800",
                "textColor": "text-sky-800",
                "hexCode": "#075985"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-sky-900",
                "textColor": "text-sky-900",
                "hexCode": "#0C4A6E"
            }
        ]
    },
    {
        "colorName": "Blue",
        "colorKey": "blue",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-blue-50",
                "textColor": "text-blue-50",
                "hexCode": "#EFF6FF"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-blue-100",
                "textColor": "text-blue-100",
                "hexCode": "#DBEAFE"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-blue-200",
                "textColor": "text-blue-200",
                "hexCode": "#BFDBFE"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-blue-300",
                "textColor": "text-blue-300",
                "hexCode": "#93C5FD"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-blue-400",
                "textColor": "text-blue-400",
                "hexCode": "#60A5FA"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-blue-500",
                "textColor": "text-blue-500",
                "hexCode": "#3B82F6"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-blue-600",
                "textColor": "text-blue-600",
                "hexCode": "#2563EB"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-blue-700",
                "textColor": "text-blue-700",
                "hexCode": "#1D4ED8"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-blue-800",
                "textColor": "text-blue-800",
                "hexCode": "#1E40AF"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-blue-900",
                "textColor": "text-blue-900",
                "hexCode": "#1E3A8A"
            }
        ]
    },
    {
        "colorName": "Indigo",
        "colorKey": "indigo",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-indigo-50",
                "textColor": "text-indigo-50",
                "hexCode": "#EEF2FF"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-indigo-100",
                "textColor": "text-indigo-100",
                "hexCode": "#E0E7FF"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-indigo-200",
                "textColor": "text-indigo-200",
                "hexCode": "#C7D2FE"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-indigo-300",
                "textColor": "text-indigo-300",
                "hexCode": "#A5B4FC"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-indigo-400",
                "textColor": "text-indigo-400",
                "hexCode": "#818CF8"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-indigo-500",
                "textColor": "text-indigo-500",
                "hexCode": "#6366F1"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-indigo-600",
                "textColor": "text-indigo-600",
                "hexCode": "#4F46E5"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-indigo-700",
                "textColor": "text-indigo-700",
                "hexCode": "#4338CA"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-indigo-800",
                "textColor": "text-indigo-800",
                "hexCode": "#3730A3"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-indigo-900",
                "textColor": "text-indigo-900",
                "hexCode": "#312E81"
            }
        ]
    },
    {
        "colorName": "Violet",
        "colorKey": "violet",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-violet-50",
                "textColor": "text-violet-50",
                "hexCode": "#F5F3FF"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-violet-100",
                "textColor": "text-violet-100",
                "hexCode": "#EDE9FE"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-violet-200",
                "textColor": "text-violet-200",
                "hexCode": "#DDD6FE"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-violet-300",
                "textColor": "text-violet-300",
                "hexCode": "#C4B5FD"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-violet-400",
                "textColor": "text-violet-400",
                "hexCode": "#A78BFA"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-violet-500",
                "textColor": "text-violet-500",
                "hexCode": "#8B5CF6"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-violet-600",
                "textColor": "text-violet-600",
                "hexCode": "#7C3AED"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-violet-700",
                "textColor": "text-violet-700",
                "hexCode": "#6D28D9"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-violet-800",
                "textColor": "text-violet-800",
                "hexCode": "#5B21B6"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-violet-900",
                "textColor": "text-violet-900",
                "hexCode": "#4C1D95"
            }
        ]
    },
    {
        "colorName": "Purple",
        "colorKey": "purple",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-purple-50",
                "textColor": "text-purple-50",
                "hexCode": "#FAF5FF"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-purple-100",
                "textColor": "text-purple-100",
                "hexCode": "#F3E8FF"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-purple-200",
                "textColor": "text-purple-200",
                "hexCode": "#E9D5FF"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-purple-300",
                "textColor": "text-purple-300",
                "hexCode": "#D8B4FE"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-purple-400",
                "textColor": "text-purple-400",
                "hexCode": "#C084FC"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-purple-500",
                "textColor": "text-purple-500",
                "hexCode": "#A855F7"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-purple-600",
                "textColor": "text-purple-600",
                "hexCode": "#9333EA"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-purple-700",
                "textColor": "text-purple-700",
                "hexCode": "#7E22CE"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-purple-800",
                "textColor": "text-purple-800",
                "hexCode": "#6B21A8"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-purple-900",
                "textColor": "text-purple-900",
                "hexCode": "#581C87"
            }
        ]
    },
    {
        "colorName": "Fuchsia",
        "colorKey": "fuchsia",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-fuchsia-50",
                "textColor": "text-fuchsia-50",
                "hexCode": "#FDF4FF"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-fuchsia-100",
                "textColor": "text-fuchsia-100",
                "hexCode": "#FAE8FF"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-fuchsia-200",
                "textColor": "text-fuchsia-200",
                "hexCode": "#F5D0FE"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-fuchsia-300",
                "textColor": "text-fuchsia-300",
                "hexCode": "#F0ABFC"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-fuchsia-400",
                "textColor": "text-fuchsia-400",
                "hexCode": "#E879F9"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-fuchsia-500",
                "textColor": "text-fuchsia-500",
                "hexCode": "#D946EF"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-fuchsia-600",
                "textColor": "text-fuchsia-600",
                "hexCode": "#C026D3"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-fuchsia-700",
                "textColor": "text-fuchsia-700",
                "hexCode": "#A21CAF"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-fuchsia-800",
                "textColor": "text-fuchsia-800",
                "hexCode": "#86198F"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-fuchsia-900",
                "textColor": "text-fuchsia-900",
                "hexCode": "#701A75"
            }
        ]
    },
    {
        "colorName": "Pink",
        "colorKey": "pink",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-pink-50",
                "textColor": "text-pink-50",
                "hexCode": "#FDF2F8"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-pink-100",
                "textColor": "text-pink-100",
                "hexCode": "#FCE7F3"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-pink-200",
                "textColor": "text-pink-200",
                "hexCode": "#FBCFE8"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-pink-300",
                "textColor": "text-pink-300",
                "hexCode": "#F9A8D4"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-pink-400",
                "textColor": "text-pink-400",
                "hexCode": "#F472B6"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-pink-500",
                "textColor": "text-pink-500",
                "hexCode": "#EC4899"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-pink-600",
                "textColor": "text-pink-600",
                "hexCode": "#DB2777"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-pink-700",
                "textColor": "text-pink-700",
                "hexCode": "#BE185D"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-pink-800",
                "textColor": "text-pink-800",
                "hexCode": "#9D174D"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-pink-900",
                "textColor": "text-pink-900",
                "hexCode": "#831843"
            }
        ]
    },
    {
        "colorName": "Rose",
        "colorKey": "rose",
        "colorCodes": [
            {
                "colorCodeName": "50",
                "colorCodeKey": "50",
                "bgColor": "bg-rose-50",
                "textColor": "text-rose-50",
                "hexCode": "#FFF1F2"
            },
            {
                "colorCodeName": "100",
                "colorCodeKey": "100",
                "bgColor": "bg-rose-100",
                "textColor": "text-rose-100",
                "hexCode": "#FFE4E6"
            },
            {
                "colorCodeName": "200",
                "colorCodeKey": "200",
                "bgColor": "bg-rose-200",
                "textColor": "text-rose-200",
                "hexCode": "#FECDD3"
            },
            {
                "colorCodeName": "300",
                "colorCodeKey": "300",
                "bgColor": "bg-rose-300",
                "textColor": "text-rose-300",
                "hexCode": "#FDA4AF"
            },
            {
                "colorCodeName": "400",
                "colorCodeKey": "400",
                "bgColor": "bg-rose-400",
                "textColor": "text-rose-400",
                "hexCode": "#FB7185"
            },
            {
                "colorCodeName": "500",
                "colorCodeKey": "500",
                "bgColor": "bg-rose-500",
                "textColor": "text-rose-500",
                "hexCode": "#F43F5E"
            },
            {
                "colorCodeName": "600",
                "colorCodeKey": "600",
                "bgColor": "bg-rose-600",
                "textColor": "text-rose-600",
                "hexCode": "#E11D48"
            },
            {
                "colorCodeName": "700",
                "colorCodeKey": "700",
                "bgColor": "bg-rose-700",
                "textColor": "text-rose-700",
                "hexCode": "#BE123C"
            },
            {
                "colorCodeName": "800",
                "colorCodeKey": "800",
                "bgColor": "bg-rose-800",
                "textColor": "text-rose-800",
                "hexCode": "#9F1239"
            },
            {
                "colorCodeName": "900",
                "colorCodeKey": "900",
                "bgColor": "bg-rose-900",
                "textColor": "text-rose-900",
                "hexCode": "#881337"
            }
        ]
    }
];
